import { GameAssetType } from '../../game-types';
import { PileType } from 'src/games/phasersolitaire/logic/logic-types';
import { GameServices } from '../../game-services';

export abstract class PileViewModel {
  public get backgroundAsset() {
    const assetName = () => {
      if (this.pileType === PileType.Deck) {
        return GameAssetType.PileDeck;
      }
      return this.pileType === PileType.Foundation
        ? GameAssetType.PileFoundation
        : GameAssetType.Pile;
    };
    return this.gameServices.assetCatalogueService.getAsset(assetName());
  }
  public get currentPileType() {
    return this.pileType;
  }

  protected readonly gameServices: GameServices;
  private readonly pileType: PileType;

  constructor(gameServices: GameServices, pileType: PileType) {
    this.gameServices = gameServices;
    this.pileType = pileType;
  }
}
